import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { setLocalCurrency } from '../../../utils/preferredCurrency';
import { actionCreators } from '../../../actions';
import CurrencyDropdown from './CurrencyDropdown';
import { changeCurrencyMutation } from './changeCurrencyMutation';
import { CurrencyProvider } from '../../CurrencyProvider/CurrencyProvider';

class CurrencySelector extends React.Component {
    constructor(props) {
        super(props);

        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.updateCurrencyComplete = this.updateCurrencyComplete.bind(this);
    }

    updateCurrencyComplete(currency) {
        const { populateCurrency } = this.props;

        setLocalCurrency(currency);
        populateCurrency(currency);
        // strip out forced currency so that you can change currency when present :
        const urlParams = new URLSearchParams(document.location.search);
        if (urlParams.get('currency')) {
            urlParams.set('currency', currency);
            window.location.search = urlParams.toString(); // reloads page
        } else {
            window.location.reload();
        }
    }

    updateCurrency(currency) {
        if (this.props.user) {
            changeCurrencyMutation({
                environment: this.props.relay.environment,
                user: this.props.user,
                currency,
                onCompleted: () => this.updateCurrencyComplete(currency),
            });
        } else {
            this.updateCurrencyComplete(currency);
        }
    }

    handleCurrencyChange(currency) {
        const category = 'navigation';
        const action = 'footer navigation click';
        const label = `change currency|${currency.toLowerCase()}`;
        const value = 0;
        const additional = { defaultCurrency: `${currency} Selected` };

        trackEvent({ category, action, label, value, additional });

        this.updateCurrency(currency);
    }

    render() {
        const currencies = get(this.props, 'viewer.currencies', []);

        return (
            <CurrencyProvider
                render={({ currency }) => (
                    <CurrencyDropdown
                        onChange={this.handleCurrencyChange}
                        currencies={currencies}
                        currency={currency}
                    />
                )}
            />
        );
    }
}

CurrencySelector.propTypes = {
    relay: PropTypes.object,
    isClient: PropTypes.bool,
    viewer: PropTypes.object,
    user: PropTypes.object,
    populateCurrency: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
    populateCurrency: currency => dispatch(actionCreators.populateCurrency(currency)),
});

export default createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(CurrencySelector),
    {
        viewer: graphql`
            fragment CurrencySelector_viewer on Viewer {
                currencies
            }
        `,
        user: graphql`
            fragment CurrencySelector_user on User {
                id
                serviceId
                profile {
                    currency
                }
            }
        `,
    }
);
